import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ComponentObservationPointDetails, SchematicDetails } from '../equipment-details.model';
import { DomSanitizer } from '@angular/platform-browser';
import { ComponentVM, SchematicDataVM } from '../../setup-implement/setup-implement.model';
import { MatDialog } from '@angular/material/dialog';
import { ObservationPointVM } from '../../favourite-dialog/favourite-dialog-modal';
import { SchemanticCompTypePopupComponent } from '../../schemantic-op-popup/schemantic-comptype-popup.component';
import { ActivatedRoute } from '@angular/router';
import { GETPreferencesService } from '../../preferences/preferences.service';

@Component({
  selector: 'app-schematic-observation-points',
  templateUrl: './schematic-observation-points.component.html',
  styleUrls: ['./schematic-observation-points.component.scss']
})
export class SchematicObservationPointsComponent implements OnInit {

  @Input() ImplementId!: number;
  @Input() SchematicOP!: ComponentObservationPointDetails[];
  @Input() schematicData: SchematicDetails = new SchematicDetails();
  @Input() schematicNonFiltData: SchematicDetails = new SchematicDetails();
  @Input() isCrack!: number;
  @Input() selectedObsPointId: number;
  @Input() ActiveCrackStatusIds: number[] = [];
  @Output() highlightobs: EventEmitter<number> = new EventEmitter();
  
  mouseoverOP: number = 0
  isCrackContains: boolean = false;
  @Input() releaseObsPointRow: boolean = true;
  componentList: ComponentVM[];
    // Schematic window.
  showSchematic: boolean = false;
  schematicPositionX: number;
  schematicPositionY: number;
  draggableSchematicTitle: string = "Schematic";
  showObservation: boolean = true;

  prevMouseX: number;
  prevMouseY: number;
  selectedSchematic: SchematicDataVM;
  allObservationPoints: ComponentObservationPointDetails[] = [];
  userUOM: string = 'mm';
  constructor(
    private _sanitizer: DomSanitizer,
    private _dialog: MatDialog, 
    private route: ActivatedRoute,
    private userPrefService: GETPreferencesService
  ) { }

  ngOnInit() {
    this.getUserPref();
    console.log("schematicOP", this.SchematicOP, this.ImplementId);
    console.log("schematicData", this.schematicData);
    console.log("activeCrackStatusIds", this.ActiveCrackStatusIds);
    if(this.ImplementId <= 0 || this.ImplementId == null || this.ImplementId == undefined){
      this.route.paramMap.subscribe(params => {
        const id = params.get('implementId');
        this.ImplementId = id ? +id : 0;
        console.log('Parent ImplementId:', this.ImplementId);
      });
    }
    if (this.SchematicOP != undefined){
      this.schematicData.ObservationPoints = [...this.SchematicOP];
      this.allObservationPoints = deepClone(this.SchematicOP);
      this.schematicNonFiltData.ObservationPoints = [...this.SchematicOP];
      console.log("ths", this.schematicNonFiltData);
      if (this.ActiveCrackStatusIds && this.ActiveCrackStatusIds.length > 0) 
        this.applyCrackFilter();
    }
      //this.loadSavedShapes();
  }

  getUserPref() {
    this.userPrefService.getUserPreferences().subscribe(res => {
      //console.log('res', res);
      this.userUOM = res.UnitOfMeasurementName;
    });
  }

  applyCrackFilter() {
    if (!this.allObservationPoints?.length) {
      this.schematicData.ObservationPoints = [];
      this.SchematicOP = [];
      return;
    }
    // this.schematicData.ObservationPoints =
    //   this.allObservationPoints.filter(op => {
    //     if (op.ObPointTypeId !== 2) {
    //       return true;
    //     }
    //     return this.ActiveCrackStatusIds.includes(op.CrackStatusId);
    // });
    this.SchematicOP =
      this.allObservationPoints.filter(op => {
        if (op.ObPointTypeId !== 2) {
          return true;
        }
        return this.ActiveCrackStatusIds.includes(op.CrackStatusId);
    });
  } 


  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['ImplementId']) {
      console.log('ImplementId received:', this.ImplementId);
    }
  }

  // ngAfterViewInit(): void {
  //   const img = this.imageRef.nativeElement;
  //   img.onload = () => {
  //     const canvas = this.canvasRef.nativeElement;
  //     canvas.width = img.clientWidth;
  //     canvas.height = img.clientHeight;
  //     canvas.style.width = img.clientWidth + 'px';
  //     canvas.style.height = img.clientHeight + 'px';
  //     this.ctx = canvas.getContext('2d')!;
  //     this.redraw();
  //   };
  // }

//   loadSavedShapes(): void {
//     this._implementService
//       .getSchematicComponentsRecognitionsDetails(this.schematicData.Id, this.ImplementId).subscribe({
//         next: (res: DrawShape[]) => {
//           this.shapes = res.map((s, index) => ({
//             id: index + 1,
//             componentId: s.componentId,
//             points: s.points ?? [],
//             locations: s.locations ?? [],
//             newLocation: ''
//           }));
// console.log("Loaded shapes:", this.shapes);
//           this.redraw();
//         },
//         error: err => {
//           console.error('Failed to load shapes', err);
//         }
//       });
//   }

  
//   redraw(): void {
//     if (!this.ctx) return;
//     const canvas = this.canvasRef.nativeElement;
//     this.ctx.clearRect(0, 0, canvas.width, canvas.height);
//     //console.log("this.shapes:", this.shapes, this.mouseIn);
//     this.shapes.forEach(shape => {
//       if (shape.points.length > 0) {
//         this.ctx.strokeStyle = '#BFEE90';
//         this.ctx.lineWidth = 2;
//         this.drawShape(shape.points, true);
//       }
//     });
//     if (this.currentPoints.length > 0) {
//       this.ctx.strokeStyle = '#BFEE90';
//       this.ctx.lineWidth = 2;
//       this.drawShape(this.currentPoints, false);
//     }
//   }

//   drawShape(points: Point[], closed: boolean): void {
//     this.ctx.beginPath();
//     this.ctx.moveTo(points[0].x, points[0].y);
//     for (let i = 1; i < points.length; i++) {
//       //this.ctx.lineTo(points[i].x, points[i].y);
//       var iPX = (points[i].x / 640.0) * 340;
//     var iPY = (points[i].y / 520.0) * 270;
//     this.ctx.lineTo(iPX, iPY);
//     }
//     if (closed) {
//       this.ctx.closePath();
//     }
//     this.ctx.stroke();
//     this.ctx.fillStyle = 'rgba(255, 255, 0, 0.1)';
//     this.ctx.fill();
//   }


  sanitize(image: string) {
    //return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
  }

  getEval(wornPct: number, inspectDate: string) {
    if ((wornPct == 0) && (inspectDate == "Never")) {
      return 'gray';
    } else if (wornPct <= 30) {
      return 'green';
    } else if ((wornPct > 30) && (wornPct <= 60)) {
      return 'yellow';
    } else if ((wornPct > 60) && (wornPct <= 80)) {
      return 'orange';
    } else if (wornPct > 80) {
      return 'red';
    }
    else {
      return 'magenta';
    }
  }

  //getPosition(posX: string, posY: string) {
  //  var iPX = (parseFloat(posX) / 640.0) * 340;
  //  var iPY = (parseFloat(posY) / 520.0) * 270;
  //  //console.log("'Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;'", 'Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;');
  //  return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;');
  //}

  getPosition(x: number, y: number): { [key: string]: string } {
    var iPX = (x / 640.0) * 340;
    var iPY = (y / 520.0) * 270;
    return {
      position: 'absolute',   // Add this if necessary for positioning
      left: `${iPX}px`,
      top: `${iPY}px`
    };
  }

  getLine(posX: string, posY: string, EndposX: string, EndposY: string, isCrackFixed: boolean, cp: ObservationPointVM) {
    // bottom right
    var x1 = (parseFloat(posX) / 640.0) * 340
    var y1 = (parseFloat(posY) / 520.0) * 270;
    // top right
    var x2 = (parseFloat(EndposX) / 640.0) * 340
    var y2 = (parseFloat(EndposY) / 520.0) * 270;
    // distance
    var length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
    // center
    var cx = (((x1 + x2) / 2) - (length / 2)) + 7;
    var cy = ((y1 + y2) / 2) - (4 / 2);
    // angle
    var angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);
    // make hr
    var colour = cp.ColorCode != null ? cp.ColorCode : (isCrackFixed == false ? "#EC0A0A" : "#63c94b");
    return this._sanitizer.bypassSecurityTrustStyle('padding:0px; margin:0px; height:' + 4 +
      'px; background-color:' + colour + '; line-height:1px; position:absolute; left:' + cx +
      'px; top:' + cy + 'px; width:' + length + 'px; -moz-transform:rotate(' + angle + 'deg); -webkit-transform:rotate(' + angle + 'deg); -o-transform:rotate(' + angle + 'deg); -ms-transform:rotate(' + angle + 'deg); transform:rotate(' + angle + 'deg);');
  }

  onMouseOverOP(id) {
    this.mouseoverOP = id;
  }

  onMouseOutOP() {
    this.mouseoverOP = 0;
  }
  openSchematicWindow(schematic) {
    console.log("Show______",schematic)

    //this.schematicPositionX = 250;
    //this.schematicPositionY = 250;

    //this.prevMouseX = 0;
    //this.prevMouseY = 0;
    //this.selectedSchematic = schematic;
    //this.showSchematic = true;
    //if (imgOrSchematic == 1) {
    //  this.draggableSchematicTitle = schematic.Name;
    //}
    schematic.ImageName = schematic.Name;
    const addSectionDialog = this._dialog.open(SchemanticCompTypePopupComponent, {
      width: '1080px',
      data: {
        schematic: schematic,
        implementId: this.ImplementId,
        activeCrackStatusIds: this.ActiveCrackStatusIds
      }
    });
    addSectionDialog.afterClosed().subscribe(r => {
      if (r) {
        //this.loadImplementSchematics();
         console.log("Close______",schematic)
      }
      console.log("Close______",schematic)
      console.log("Close______ob",this.allObservationPoints);
      this.schematicData.ObservationPoints = this.allObservationPoints;
    });
  }

  onCloseSchematicWindow() {
    this.showSchematic = false;
  }
  // chekImagecontainsCracks(){
  //     for(let i=0; i<this.SchematicOP.Type)
  // }
  onMouseEnter(obsPointId: number) {
    //console.log("this.releaseObsPointRow over:", this.releaseObsPointRow);
    if (this.releaseObsPointRow) {
      this.highlightobs.emit(obsPointId);
      this.selectedObsPointId = obsPointId;
    }
  }

  onMouseClick(obsPointId: number) {
    //console.log("this.releaseObsPointRow click:", this.releaseObsPointRow);
    this.onMouseEnter(obsPointId);
    this.releaseObsPointRow = !this.releaseObsPointRow;
    //console.log("this.releaseObsPointRow after click:", this.releaseObsPointRow);
  }

}

export function deepClone<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}
